import React from 'react';
import { theme } from '../../config/theme';

const Pagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange,
  hasNextPage,
  hasPreviousPage,
  totalItems,
  itemsPerPage,
}) => {
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    
    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) pages.push(i);
        pages.push('...');
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1);
        pages.push('...');
        for (let i = totalPages - 3; i <= totalPages; i++) pages.push(i);
      } else {
        pages.push(1);
        pages.push('...');
        pages.push(currentPage - 1);
        pages.push(currentPage);
        pages.push(currentPage + 1);
        pages.push('...');
        pages.push(totalPages);
      }
    }
    
    return pages;
  };

  const buttonStyles = (active = false, disabled = false) => ({
    padding: `${theme.spacing.sm} ${theme.spacing.md}`,
    border: `1px solid ${active ? theme.colors.primary.main : theme.colors.gray[300]}`,
    borderRadius: theme.borderRadius.md,
    backgroundColor: active ? theme.colors.primary.main : theme.colors.white,
    color: active ? theme.colors.white : theme.colors.text.primary,
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.5 : 1,
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.medium,
    transition: theme.transitions.base,
    minWidth: '36px',
  });

  const containerStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing.xl,
    gap: theme.spacing.md,
    flexWrap: 'wrap',
  };

  const pageNumbersStyles = {
    display: 'flex',
    gap: theme.spacing.xs,
    alignItems: 'center',
  };

  const infoStyles = {
    fontSize: theme.typography.fontSize.sm,
    color: theme.colors.text.secondary,
  };

  if (totalPages <= 1) return null;

  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <div style={containerStyles}>
      <div style={infoStyles}>
        Showing {startItem} to {endItem} of {totalItems} results
      </div>

      <div style={pageNumbersStyles}>
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={!hasPreviousPage}
          style={buttonStyles(false, !hasPreviousPage)}
        >
          ← Previous
        </button>

        {getPageNumbers().map((page, index) => (
          page === '...' ? (
            <span key={`ellipsis-${index}`} style={{ padding: `0 ${theme.spacing.xs}` }}>
              ...
            </span>
          ) : (
            <button
              key={page}
              onClick={() => onPageChange(page)}
              style={buttonStyles(page === currentPage)}
            >
              {page}
            </button>
          )
        ))}

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={!hasNextPage}
          style={buttonStyles(false, !hasNextPage)}
        >
          Next →
        </button>
      </div>
    </div>
  );
};

export default Pagination;